export default {
  // data () {
  //   return {
  //     gtagData: null
  //   }
  // },
  mounted () {
  },
  // beforeDestroy () {
  //   this.$root.$off('scroll-end', this.scrollStopHandler)
  // },
  methods: {
    initGtag (obj) {
      // this.gtagData = obj
      // console.log('initGtag', obj)
      delete obj.element.dataset.isExposed

      this.$root.$on('scroll-end', () => {
        this.scrollStopHandler(obj)
      })
      window.addEventListener('load', () => {
        this.scrollStopHandler(obj)
      })
    },
    async scrollStopHandler (obj) {
      const el = obj.element
      // const { top, right, bottom } = el.getBoundingClientRect()

      async function isElementInScrollView (element) {
        return new Promise((resolve) => {
          const observer = new IntersectionObserver(
            (entries, observerItself) => {
              observerItself.disconnect()
              // resolve(entries[0].intersectionRatio === 1)
              resolve(entries[0].isIntersecting)
            }
          )
          observer.observe(element)
        })
      }

      // if (
      //   ((top <= window.innerHeight && top >= 0) ||
      //     (bottom <= window.innerHeight && bottom >= 0)) &&
      //   right <= window.innerWidth &&
      //   right > 0
      // ) {
      if (await isElementInScrollView(el)) {
        if (el.dataset.isExposed === 'true') {
          return
        }

        if (obj.custom) {
          obj.custom()
        } else {
          this.setGtag({ ...obj.ga, action: 'view' })

          if (obj.isView) {
            //
          } else {
            el.addEventListener('click', () => {
              this.setGtag({ ...obj.ga, action: 'click' })
            })
          }
        }

        el.dataset.isExposed = 'true'
      }
    },
    setGtag (params) {
      if (!params.action) {
        params.action = 'click'
      }

      this.$gtag.event(params.name, {
        ...params,
        lang: this.$i18n.locale,
        site_type: process.env.VUE_APP_PROFILE
      })

      // console.log(params.name, {
      //   ...params,
      //   lang: this.$i18n.locale,
      //   site_type: process.env.VUE_APP_PROFILE
      // })

      // if (process.env.NODE_ENV === 'production') {
      //   this.$gtag.event(params.name, {
      //     ...params,
      //     lang: this.$i18n.locale,
      //     site_type: process.env.VUE_APP_PROFILE
      //   })
      // } else {
      //   console.log({
      //     action: params.action,
      //     ...params,
      //     lang: this.$i18n.locale,
      //     site_type: process.env.VUE_APP_PROFILE
      //     // label: params.label
      //   })
      // }
    },
    scrollEvent () {
      console.log('scroll-stop end')
    },
  }
}
